export const API_GET_ALL_SPECIAL_REGIME = 'API_GET_ALL_SPECIAL_REGIME'
export const API_GET_ALL_SPECIAL_REGIME_SUCCESS = 'API_GET_ALL_SPECIAL_REGIME_SUCCESS'
export const API_GET_ALL_SPECIAL_REGIME_FAIL = 'API_GET_ALL_SPECIAL_REGIME_FAIL'

export const API_ADMIN_GET_ALL_SPECIAL_REGIME = 'API_ADMIN_GET_ALL_SPECIAL_REGIME'
export const API_ADMIN_GET_ALL_SPECIAL_REGIME_SUCCESS = 'API_ADMIN_GET_ALL_SPECIAL_REGIME_SUCCESS'
export const API_ADMIN_GET_ALL_SPECIAL_REGIME_FAIL = 'API_ADMIN_GET_ALL_SPECIAL_REGIME_FAIL'

export const API_ADMIN_GET_SPECIAL_REGIME = 'API_ADMIN_GET_SPECIAL_REGIME'
export const API_ADMIN_GET_SPECIAL_REGIME_SUCCESS = 'API_ADMIN_GET_SPECIAL_REGIME_SUCCESS'
export const API_ADMIN_GET_SPECIAL_REGIME_FAIL = 'API_ADMIN_GET_SPECIAL_REGIME_FAIL'

export const API_ADMIN_POST_SPECIAL_REGIME = 'API_ADMIN_POST_SPECIAL_REGIME';
export const API_ADMIN_POST_SPECIAL_REGIME_SUCCESS = 'API_ADMIN_POST_SPECIAL_REGIME_SUCCESS';
export const API_ADMIN_POST_SPECIAL_REGIME_FAIL = 'API_ADMIN_POST_SPECIAL_REGIME_FAIL';

export const API_ADMIN_PATCH_SPECIAL_REGIME = 'API_ADMIN_PATCH_SPECIAL_REGIME';
export const API_ADMIN_PATCH_SPECIAL_REGIME_SUCCESS = 'API_ADMIN_PATCH_SPECIAL_REGIME_SUCCESS';
export const API_ADMIN_PATCH_SPECIAL_REGIME_FAIL = 'API_ADMIN_PATCH_SPECIAL_REGIME_FAIL';

export const API_ADMIN_DELETE_SPECIAL_REGIME = 'API_ADMIN_DELETE_SPECIAL_REGIME';
export const API_ADMIN_DELETE_SPECIAL_REGIME_SUCCESS = 'API_ADMIN_DELETE_SPECIAL_REGIME_SUCCESS';
export const API_ADMIN_DELETE_SPECIAL_REGIME_FAIL = 'API_ADMIN_DELETE_SPECIAL_REGIME_FAIL';

export const ADMIN_INIT_NEW_SPECIAL_REGIME = 'ADMIN_INIT_NEW_SPECIAL_REGIME'

export const ADMIN_RESET_FOCUS_SPECIAL_REGIME = 'ADMIN_RESET_FOCUS_SPECIAL_REGIME'